<template>
    <integration-custom-domain is-onboarding-integration/>
</template>

<script>
import {defineComponent} from 'vue'
import IntegrationCustomDomain from "../../settings/integrations/IntegrationCustomDomain.vue";

export default defineComponent({
  name: "OnboardingStepCustomEmail",
  components: {IntegrationCustomDomain},
})
</script>

<style scoped lang="scss">

</style>
